import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_user_approve",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-500px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "New User Approval")
], -1)
const _hoisted_9 = { class: "text-left ms-7" }
const _hoisted_10 = { class: "row mb-7" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "University:", -1)
const _hoisted_12 = { class: "col-lg-7 fv-row" }
const _hoisted_13 = { class: "fw-bold fs-6" }
const _hoisted_14 = { class: "row mb-7" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "Full Name:", -1)
const _hoisted_16 = { class: "col-lg-7 fv-row" }
const _hoisted_17 = { class: "fw-bold fs-6" }
const _hoisted_18 = { class: "row mb-7" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "Email:", -1)
const _hoisted_20 = { class: "col-lg-7 fv-row" }
const _hoisted_21 = { class: "fw-bold fs-6" }
const _hoisted_22 = { class: "row mb-7" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "Phone:", -1)
const _hoisted_24 = { class: "col-lg-7 fv-row" }
const _hoisted_25 = { class: "fw-bold fs-6" }
const _hoisted_26 = { class: "row mb-7" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "User Type:", -1)
const _hoisted_28 = { class: "col-lg-7 fv-row" }
const _hoisted_29 = { class: "badge badge-info text-uppercase" }
const _hoisted_30 = { class: "row mb-7" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold fs-6" }, "Registered Date:", -1)
const _hoisted_32 = { class: "col-lg-7 fv-row" }
const _hoisted_33 = { class: "fw-bold fs-6" }
const _hoisted_34 = { class: "card-footer d-flex justify-content-center py-6 px-9" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Approve ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Reject ", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.currentUserEdit.piUniversity || ""), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.currentUserEdit.piFirstname || "") + " " + _toDisplayString(_ctx.currentUserEdit.piLastName || ""), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.currentUserEdit.piEmail), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.currentUserEdit.piPhoneNumber), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.currentUserEdit.piRole), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.moment(_ctx.currentUserEdit.createdDate)), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("button", {
            type: "submit",
            id: "id_approve_button",
            ref: "approveButton",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approve(_ctx.currentUserEdit))),
            class: "btn btn-success mx-4"
          }, _hoisted_37, 512),
          _createElementVNode("button", {
            type: "submit",
            id: "id_reject_button",
            ref: "rejectButton",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reject(_ctx.currentUserEdit))),
            class: "btn btn-danger"
          }, _hoisted_40, 512)
        ])
      ])
    ])
  ]))
}